import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import countries from '../../../json/country.json'
import { stripHtml } from '../../../helpers/stripHtml'
import { MySwal } from '../../../lib/swal'

const EditParticipantComp = (props) => {
    // console.log(props)
    const [required, setRequired] = useState(false);
    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }
    const dispatch = useDispatch()
    const participants = useSelector(state => state.participants)


    const [namaDepanPeserta, setNamaDepanPeserta] = useState(props.participant.namaDepanPeserta);
    const [namaBelakangPeserta, setNamaBelakangPeserta] = useState(props.participant.namaBelakangPeserta);
    const [salutationPeserta, setSalutationPeserta] = useState(props.participant.salutationPeserta);
    const [jabatanPeserta, setJabatanPeserta] = useState(props.participant.jabatanPeserta);
    const [kodeHpPeserta, setKodeHpPeserta] = useState(props.participant.kodeHpPeserta);
    const [hpPeserta, setHpPeserta] = useState(props.participant.hpPeserta);
    const [emailPeserta, setEmailPeserta] = useState(props.participant.emailPeserta);

    const handleUpdateParticipant = () => {
        if (
            namaBelakangPeserta.length === 0 ||
            salutationPeserta.length === 0 ||
            jabatanPeserta.length === 0 ||
            emailPeserta.length === 0
        ) {
            // alert('masuk atas')
            setRequired(true)
        } else {
            // alert('masuk bawah')
            if (hpPeserta.length > 8) {
                const checkIsExist = participants.some(
                    item => emailPeserta === item.emailPeserta &&
                        props.programId === item.programId
                );
                const newHp = hpPeserta.replace(kodeHpPeserta, '')
                if (checkIsExist === true) {
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Oops, Kesalahan!',
                        text: 'Email Peserta sudah terdaftar.',
                        confirmButtonColor: '#6e7d88',
                    })
                } else {
                    const obj = {
                        idPeserta: props.participant.idPeserta,
                        programId: props.participant.programId,
                        namaDepanPeserta: namaDepanPeserta,
                        namaBelakangPeserta: namaBelakangPeserta,
                        salutationPeserta: salutationPeserta,
                        jabatanPeserta: jabatanPeserta,
                        kodeHpPeserta: kodeHpPeserta,
                        hpPeserta: kodeHpPeserta.concat(newHp),
                        emailPeserta: emailPeserta,
                    }
                    dispatch({
                        type: 'UPDATE_PARTICIPANTS',
                        payload: obj
                    });

                    const objParticipants = {
                        emailOld: props.participant.emailPeserta,
                        firstName: namaDepanPeserta,
                        lastName: namaBelakangPeserta,
                        email: emailPeserta,
                        mobilePhone: kodeHpPeserta.concat(newHp),
                        position: jabatanPeserta,
                    }
                    dispatch({
                        type: 'UPDATE_PARTICIPANT_TO_SCHEDULE',
                        payload: objParticipants,
                        programId: props.participant.programId,
                    });

                    props.close()
                }
            } else {
                setRequired(true)
                MySwal.fire({
                    icon: 'warning',
                    title: 'Oops, Kesalahan!',
                    text: 'Nomor Handphone minimal 9 digit.',
                })
            }
        }
    }

    // console.log(participants)

    return (
        <>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaDepan' className="form-label">Nama Depan</label>
                    <input type="text" id='NamaDepan' className="form-control" onChange={(e) => setNamaDepanPeserta(stripHtml(e.target.value))} value={namaDepanPeserta} />
                </div>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (namaBelakangPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor='NamaBelakang' className="form-label required">Nama Belakang</label>
                    <input type="text" id='NamaBelakang' className="form-control" onChange={(e) => setNamaBelakangPeserta(stripHtml(e.target.value))} value={namaBelakangPeserta}
                        style={{ borderColor: (namaBelakangPeserta.length === 0 && required === true) ? '#F1416C' : '' }}
                    />
                </div>
                <p className='mt-3'>Apabila nama anda terdiri dari satu kata: Nama Depan : <b>Budianto</b>, Nama Belakang : <b>Budianto</b></p>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (salutationPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor="salutationPeserta" className="form-label required">Sapaan / Salutation</label>
                    <select className="form-select" aria-label="Select example" id='salutationPeserta' onChange={(e) => setSalutationPeserta(e.target.value)} value={salutationPeserta}
                        style={{ borderColor: (salutationPeserta.length === 0 && required === true) ? '#F1416C' : '' }}
                    >
                        <option value=''>Pilih</option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Ms'>Ms</option>
                    </select>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='JabatanIndividu' className="form-label required">Jabatan</label>
                    <input type="text" id='JabatanIndividu' className="form-control mb-3" placeholder='Jabatan' onChange={(e) => setJabatanPeserta(stripHtml(e.target.value))} value={jabatanPeserta} style={{ borderColor: (jabatanPeserta.length === 0 && required === true) ? '#F1416C' : '' }} />
                </div>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='row col-lg-12'>
                    <div className='col-lg-4 col-12'>
                        <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='Country' className="form-label required">Negara</label>
                        <select className="form-select" id='Country' onChange={(e) => setKodeHpPeserta(e.target.value)} value={kodeHpPeserta}>
                            <option value="+62">Indonesia ({kodeHpPeserta})</option>
                            {countries.countries.map((country, key) =>
                                <option value={country.code}>{country.name} ({country.code})</option>
                            )}
                        </select>
                    </div>
                    <div className='col-lg-8 col-12'>
                        <label style={{ fontSize: '16px', fontWeight: '600', color: (hpPeserta.length < 16 && required === true) ? '#F1416C' : '' }} htmlFor='Country' className="form-label required">Nomor Handphone</label>
                        <input type="text" id='Country' className="form-control" placeholder='81234567890' onChange={(e) => setHpPeserta(e.target.value)} value={hpPeserta}
                            style={{ borderColor: (hpPeserta.length < 16 && required === true) ? '#F1416C' : '' }}
                        />
                    </div>
                    <p className='mt-3'>Gunakan nomor yang terhubung dengan WhatsApp</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (emailPeserta.length === 0 && required === true) ? '#F1416C' : '' }} htmlFor='Email' className="form-label required">Email</label>
                    <input type="email" id='Email' className="form-control" onChange={(e) => setEmailPeserta(e.target.value)} value={emailPeserta}
                        style={{ borderColor: (emailPeserta.length === 0 && required === true) ? '#F1416C' : '' }}
                    />
                </div>
            </div>
            <div className='d-flex justify-content-end mt-3 mb-3'>
                {
                    <button style={{ fontSize: size.width < 500 ? '15px' : '20px', fontWeight: '400', backgroundColor: '#26D07C', color: '#F2F2F2' }} type='button' className='btn btn-success' onClick={handleUpdateParticipant}>Simpan</button>
                }
            </div>
        </>
    )
}

export default EditParticipantComp
